var map = {
	"./en/01/meta.json": "./src/lib/lessons/en/01/meta.json",
	"./ko/01/meta.json": "./src/lib/lessons/ko/01/meta.json",
	"./ko/02/meta.json": "./src/lib/lessons/ko/02/meta.json",
	"./ko/03/meta.json": "./src/lib/lessons/ko/03/meta.json",
	"./ko/04/meta.json": "./src/lib/lessons/ko/04/meta.json",
	"./ko/05/meta.json": "./src/lib/lessons/ko/05/meta.json",
	"./ko/06/meta.json": "./src/lib/lessons/ko/06/meta.json",
	"./ko/07/meta.json": "./src/lib/lessons/ko/07/meta.json",
	"./ko/08/meta.json": "./src/lib/lessons/ko/08/meta.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/lib/lessons sync recursive meta\\.json$";